import { Title } from '../../../../../components/Title';
import claimPayIcon from '../../../../../assets/claim-pay-icon.svg';

export const OTPTitle = () => <Title title='One-time Password'>
  <img alt='claimpay' src={claimPayIcon} />
</Title>;